import styles from "./ExtendedReturnsPolicy.module.scss";

type Props = {
  startDate: string;
  endDate: string;
  deadlineDate: string;
};

export function ExtendedReturnsPolicy({
  startDate = "",
  endDate = "",
  deadlineDate = "",
}: Props) {
  if (!startDate || !endDate || !deadlineDate) return null;

  return (
    <div>
      <p className={styles.headline}>Our extended Christmas returns policy</p>
      <p>
        We&apos;ve extended our usual limit for returns just for the festive
        season. Any gift bought between {startDate} and {endDate} can be
        returned up until {deadlineDate}, if it&apos;s unwanted or unsuitable.
      </p>
    </div>
  );
}
